import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTedComponent } from './simple-icons-ted.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTedComponent ],
    exports:      [ SimpleIconsTedComponent ],
    bootstrap:    []
})
export class SimpleIconsTedModule {}
